var map = {
	"./coupon_center.vue": 71653,
	"./evaluation.vue": 89140,
	"./goods_cate.vue": 78901,
	"./goods_coupon.vue": 31253,
	"./goods_detail/_id/index.vue": 39732,
	"./goods_list.vue": 32511,
	"./goods_presell.vue": 30590,
	"./goods_presell_detail/_id/index.vue": 26233,
	"./goods_ranking/_cate_id.vue": 99451,
	"./goods_search.vue": 941,
	"./goods_seckill.vue": 46161,
	"./goods_seckill_detail/_id/index.vue": 63,
	"./index.vue": 69766,
	"./login.vue": 40547,
	"./logistics.vue": 51192,
	"./logistics_delivery.vue": 13415,
	"./merchant_settled.vue": 19889,
	"./news_detail/_id/index.vue": 12539,
	"./news_list.vue": 86507,
	"./order_confirm.vue": 44422,
	"./order_detail.vue": 76396,
	"./order_stay_detail.vue": 44097,
	"./payment.vue": 84808,
	"./privacy_agreement.vue": 37385,
	"./qualifications.vue": 51830,
	"./refund.vue": 11424,
	"./refund_confirm.vue": 71133,
	"./refund_detail.vue": 48051,
	"./refund_goods.vue": 25965,
	"./refund_logistics.vue": 61898,
	"./shop_more.vue": 71309,
	"./shop_street.vue": 85007,
	"./shopping_cart.vue": 76021,
	"./store.vue": 29917,
	"./store/category.vue": 3583,
	"./store/index.vue": 19847,
	"./store/storeCoupon.vue": 26763,
	"./user.vue": 11228,
	"./user/address_list.vue": 77378,
	"./user/balance.vue": 57618,
	"./user/collect.vue": 10879,
	"./user/index.vue": 37421,
	"./user/integral.vue": 22442,
	"./user/invoice_list.vue": 87073,
	"./user/my_coupon.vue": 1060,
	"./user/order_list.vue": 96916,
	"./user/presell_order.vue": 76760,
	"./user/refund_list.vue": 21344,
	"./user/refund_select.vue": 14875,
	"./user/settle_record.vue": 45705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73853;